define('catalogsDetailDetailsView',[
  'module',
  'marionette',
  'underscore',
  'app',
  'template!catalogsDetailDetailsTpl',
  'dynamicTextView',
  'buttonView'
], function (
  Module,
  Marionette,
  _,
  App,
  Tpl,
  DynamicTextView,
  ButtonView
) {
  'use strict';

  Module.exports = Marionette.LayoutView.extend({
    template: Tpl,
    className: 'catalogs-detail-details-view',

    regions: {
      nameRegion: '.name-region',
      actionsRegion: '.actions-region'
    },

    initialize: function () {
      this.model = this.options.viewOptions.model;
    },

    onShow: function () {
      // Ensure DynamicText model on name relation
      var nameModel = this.model && this.model.get && this.model.get('name');
      if (!nameModel || !_.isFunction(nameModel.getTranslationCollection)) {
        nameModel = App.request('dynamic-text:model', { values: {} });
        if (this.model && this.model.set) this.model.set('name', nameModel);
      }

      this.nameDtView = new DynamicTextView({
        model: nameModel,
        noSaving: true,
        hideGlossary: true
      });
      this.getRegion('nameRegion').show(this.nameDtView);

      this.saveButtonView = new ButtonView({
        type: 'save',
        color: 'orange',
        text: _.i18n('common.save') || 'Save',
        title: _.i18n('common.save') || 'Save'
      });
      this.getRegion('actionsRegion').show(this.saveButtonView);
      this.saveButtonView.on('click', _.bind(this.onSave, this));
    },

    onSave: function () {
      var id = this.model.get('secId');
      this.saveButtonView.loading(true);
      App.request('catalog:update', id, this.model.toJSON())
        .done(_.bind(function (updated) {
          // Ensure local model stays in sync
          if (updated && updated.get) {
            this.model.set(updated.toJSON());
          }
        }, this))
        .fail(function (xhr) {
          if (window && window.alert) {
            var msg = (xhr && xhr.responseJSON && xhr.responseJSON.message) || 'Failed to save catalog';
            window.alert(msg);
          }
        })
        .always(_.bind(function(){
          this.saveButtonView.loading(false);
        }, this));
    }
  });
});

